import React from 'react';

import { NamedLink } from '../../components';

import css from './ListingPage.module.css';

const ListingBreadcrumbs = ({ category, categorySlug, title }) => (
  <nav className={css.breadcrumbs} aria-label="Breadcrumb">
    <ol>
      <li>
        <NamedLink name="LandingPage">Home</NamedLink>
      </li>
      <li>
        {categorySlug ? (
          <NamedLink name="CategoryPage" params={{ category: categorySlug }}>
            {category} vacation rentals
          </NamedLink>
        ) : (
          <NamedLink name="SearchPage">Vacation rentals</NamedLink>
        )}
      </li>
      <li aria-current="page">{title}</li>
    </ol>
  </nav>
);

export default ListingBreadcrumbs;
